import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonIcon } from '@ionic/react';
import { documentTextOutline } from 'ionicons/icons';
import { Link } from 'react-router-dom';
import { get_doc_thumb_url } from '@/controllers/backend'
import Image from '@/components/Image'

const DocumentList: React.FC<{ title: string; subtitle: string; docs: string[]; repo_id: string }> = ({ title, subtitle, docs, repo_id }) => {
    return (<>
        <IonCard className="bg-white dark:bg-gray-800 shadow-lg m-0 py-2 px-2 rounded-none">
    {docs.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-0 ">
            {docs.map((doc, index) => (
                <Link to={`/docs/${doc.id}/${doc.name}`} key={index} className="block pb-6">
                    <IonCard className="bg-white dark:bg-gray-700 shadow-md rounded-lg overflow-hidden h-full transition-transform duration-300 hover:scale-105 hover:shadow-lg">
                        <div className="relative pb-[140%]">
                            <Image src={get_doc_thumb_url(doc.id)} alt={doc.name} />
                        </div>
                        <IonCardContent className="p-0 mx-2 mt-3">
                            <h3 className="font-bold text-gray-800 dark:text-white text-center break-all">{doc.name.slice(0,32)}</h3>
                        </IonCardContent>
                    </IonCard>
                </Link>
            ))}
        </div>
    ) : (
        <div className="p-8 text-center">
            <IonIcon icon={documentTextOutline} className="text-4xl text-gray-400 dark:text-gray-500 mx-auto mb-4" />
            <p className="text-gray-500 dark:text-gray-400">No documents uploaded yet</p>
        </div>
    )}
    </IonCard>
    </>);
};

export default DocumentList;
